import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FormsModule } from '@angular/forms';

import { SidebarComponent } from './sidebar.component';
import { DirectivesModule } from '../directives/directives.module';

@NgModule({
    imports: [ RouterModule, CommonModule, FormsModule, DirectivesModule ],
    declarations: [ SidebarComponent ],
    exports: [ SidebarComponent ]
})

export class SidebarModule {}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.module.ts